import { Check, Loader2 } from "lucide-react";

// PATCH 36 Me5 — an unobtrusive auto-save signal. status: "idle" | "saving" | "saved".
export default function SavedIndicator({ status = "idle", label, testid = "saved-indicator" }) {
  if (status === "idle") return null;
  const saving = status === "saving";
  return (
    <span data-testid={testid} aria-live="polite" className="k-muted"
      style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12 }}>
      {saving
        ? <><Loader2 size={12} className="k-spin" aria-hidden="true" /> Saving…</>
        : <><Check size={12} aria-hidden="true" /> {label || "Saved"}</>}
    </span>
  );
}
